// extracted by mini-css-extract-plugin
module.exports = {"main":"Ux_main__1hmWE","link":"Ux_link__X8Vvb","heading":"Ux_heading__TxewS","arrow":"Ux_arrow__QexOV","projects":"Ux_projects__1BbwG"};